"use strict";

exports.__esModule = true;
exports.CookieConsentWrapper = exports.CookieConsentContent = exports.Container = exports.Button = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _polished = require("polished");

var _Container = _interopRequireDefault(require("../grid/Container/Container"));

var _Button = _interopRequireDefault(require("../../buttons/Button/Button"));

var _breakpoints = require("../../../helpers/breakpoints");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// animation to show the overlay behind the modal on mobile
const showCookieModalOverlay = (0, _styledComponents.keyframes)`
    0% {opacity: 0;}
    66% {opacity: 0;}
    100% {opacity: 1;}
`; // animation to show the modal on mobile

const showCookieModal = (0, _styledComponents.keyframes)`
    0% {opacity: 0; transform: translateY(-80px);}
    75% {opacity: 0; transform: translateY(-80px);}
    100% {opacity: 1; transform: transformY(0);}
`;
const CookieConsentWrapper = _styledComponents.default.div`
    position: fixed;
    display: flex;
    align-items: center;
    z-index: 1000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    padding: 0 ${({
  theme
}) => theme.space[5]};
    color: ${({
  theme
}) => theme.colors.modals.text};
    background-color: ${({
  theme
}) => theme.colors.modals.overlay};
    animation-name: ${showCookieModalOverlay};
    animation-duration: 750ms;

    ${_breakpoints.breakpointUp.sm`
        top: auto;
        height: auto;
        color: ${({
  theme
}) => theme.colors.cookieConsent.text};
        background-color: ${({
  theme
}) => theme.colors.cookieConsent.background};
        border-top: 1px solid ${({
  theme
}) => theme.colors.cookieConsent.border};
        opacity: 1;
        padding: 0;
        animation-name: none;
    `}

    ${props => props.hiding && (0, _styledComponents.css)`
        background-color: ${({
  theme
}) => theme.colors.transparent};
        transition: background-color 300ms ease-in;
        transition-delay: 300ms;

        ${_breakpoints.breakpointUp.sm`
            transform: translateY(100%);
            transition: transform 250ms ease-in;
            transition-delay: 0;
        `};
    `};

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
exports.CookieConsentWrapper = CookieConsentWrapper;
const StyledContainer = (0, _styledComponents.default)(_Container.default)`
    width: auto;
    background-color: ${({
  theme
}) => theme.colors.white};
    padding-top: 20px;
    border-radius: 5px;
    animation-name: ${showCookieModal};
    animation-duration: 1s;
    animation-timing-function: ease-out;

    ${_breakpoints.breakpointUp.sm`
        display: flex;
        align-items: center;
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        min-height: 75px;
        width: 100%;
        padding-top: 0;
        border: none;
        border-radius: 0;
        background-color: ${({
  theme
}) => theme.colors.transparent};
        animation-name: none;
    `}

    ${props => props.hiding && (0, _styledComponents.css)`
        transform: translateY(-80px);
        opacity: 0;
        transition: all 250ms ease-in;

        ${_breakpoints.breakpointUp.sm`
            opacity: 1;
            transform: none;
        `};
    `}; 
`;
exports.Container = StyledContainer;
const CookieConsentContent = _styledComponents.default.div`
    margin: 15px 0 25px 0;

    ${_breakpoints.breakpointUp.sm`
        width: calc(100% - 150px);
        margin: 15px 0;
    `}

    ${_breakpoints.breakpointUp.xl`
        width: calc(100% - 180px);
    `}

    & > p {
        margin: 0;
    }

`;
exports.CookieConsentContent = CookieConsentContent;
const StyledButton = (0, _styledComponents.default)(_Button.default)`
    width: 100%;
    margin: 0 15px 15px 0;

    ${_breakpoints.breakpointUp.sm`
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 140px;
        margin: 0 15px 0 0;
    `}
`;
exports.Button = StyledButton;